module.exports = __webpack_public_path__ + "2413c829877642363be1f9649830dcd8.png";